import { Trash2 } from 'lucide-react';
import React from 'react';
import type { SenderProfile } from '../../../lib/api';
import styles from './sender-profiles.module.css';

type EditableField = 'label' | 'nameFieldPath' | 'emailFieldPath';

interface SenderProfileEditRowProps {
  profile: SenderProfile;
  schemaProperties: string[];
  onUpdate: (profileId: string, field: EditableField, value: string) => void;
  onRemove: (profileId: string) => void;
}

const SELECT_FIELDS: ReadonlyArray<{
  key: 'nameFieldPath' | 'emailFieldPath';
  label: string;
}> = [
  { key: 'nameFieldPath', label: 'Name field' },
  { key: 'emailFieldPath', label: 'Email field' },
];

export const SenderProfileEditRow: React.FC<SenderProfileEditRowProps> = ({
  profile,
  schemaProperties,
  onUpdate,
  onRemove,
}) => {
  return (
    <li className={styles.profileEditor}>
      <fieldset>
        <legend>{profile.label || 'Sender profile'}</legend>

        <label>
          Label
          <input
            type="text"
            value={profile.label}
            onChange={e => onUpdate(profile.profileId, 'label', e.target.value)}
            placeholder="e.g. Sales rep"
          />
        </label>

        {SELECT_FIELDS.map(({ key, label }) => (
          <label key={key}>
            {label}
            <select
              value={profile[key]}
              onChange={e => onUpdate(profile.profileId, key, e.target.value)}>
              <option value="">Select field...</option>
              {schemaProperties.map(prop => (
                <option key={prop} value={prop}>
                  {prop}
                </option>
              ))}
            </select>
          </label>
        ))}

        <button type="button" onClick={() => onRemove(profile.profileId)} aria-label="Remove profile">
          <Trash2 />
        </button>
      </fieldset>
    </li>
  );
};
